module.exports = __webpack_public_path__ + "img/left-silver.6539681.jpg";